module.exports = __webpack_public_path__ + "img/ic_selfawareness.faf26f8b.png";